import { toast } from "react-toastify";
import Loader from "src/components/common/Loader/Loader";
import { useDeleteBusScheduleSimulate } from "src/services/react-query-apis/delete-bus-schedule-simulate";
import { useDeleteBusScheduleMutation } from "src/services/react-query-apis/delete-bus-schedule";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { getCurrentMonth } from "src/services/auth/token";
import BusScheduleAffectedAttendances from "./bus-schedule-affected-attendances";

const ScheduleDeleteConfirm = ({ scheduleId, busCourseId, onClose }) => {
  const deleteScheduleSimulateQuery = useDeleteBusScheduleSimulate({
    busCourseId: busCourseId,
    id: scheduleId,
    queryConfig: {
      staleTime: 0,
    },
  });

  const mutationConfig = {
    onSuccess: async data => {
      toast.success(data.message);
      onClose();
    },
  };

  const deleteScheduleMutation = useDeleteBusScheduleMutation({
    mutationConfig,
  });

  if (deleteScheduleSimulateQuery.isFetching) {
    return <Loader message="データを取得中..." />;
  }

  if (deleteScheduleSimulateQuery.isError) {
    return (
      <>
        <div className="text-danger text-center mb-3 p-1 rounded bg-light border fw-bold">
          {deleteScheduleSimulateQuery.error.response?.data?.message ||
            "エラーが発生しました"}
        </div>
        <div className="text-end">
          <button className="btn btn-primary" onClick={onClose}>
            閉じる
          </button>
        </div>
      </>
    );
  }

  const { affected_attendances, can_delete } = deleteScheduleSimulateQuery.data
    ?.data || { affected_attendances: [], can_delete: true };
  const hasAffectedAttendances =
    affected_attendances && affected_attendances.length > 0;

  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex flex-column w-100">
        <div>
          <div
            className="alert alert-warning mb-3 text-center p-1"
            role="alert"
          >
            <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
            この変更は{" "}
            {moment(getCurrentMonth())
              .add(1, "month")
              .format("YYYY年MM月")}{" "}
            から適用されます
          </div>
          {affected_attendances.length > 0 && (
            <div className="mb-3">
              <h6 className="text-center mb-3">影響を受ける出席予定</h6>
              <BusScheduleAffectedAttendances
                affectedAttendances={affected_attendances}
              />
            </div>
          )}
          {!can_delete && (
            <div className="alert alert-warning text-center mb-3" role="alert">
              <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
              影響を受ける出席予定を処理してから再度お試しください
            </div>
          )}
          <div className="d-flex gap-2 justify-content-end mt-3">
            <button className="btn btn-secondary px-4" onClick={onClose}>
              閉じる
            </button>
            <button
              className="btn btn-danger px-4"
              onClick={() => {
                deleteScheduleMutation.mutate({ busCourseId, id: scheduleId });
              }}
              disabled={deleteScheduleMutation.isPending || !can_delete}
            >
              {deleteScheduleMutation.isPending ? "処理中..." : "削除"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleDeleteConfirm;
